import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

export function SportsbookViewerSkeleton({ className }: { className?: string }) {
	return <Skeleton className={cn('min-h-0 w-full flex-1 rounded-none', className)} />
}
